import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux';
import Config from '../config.ts';
import App from "./App.tsx";
import "./index.css";
import store from './reducers/store.ts';
import "./styles.css";

Config();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
        <App />
    </Provider>
  </StrictMode>,
);